const initialState = {
  recaptcha_public_v2: ''
}

const generalReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_RECAPTCHA': return { ...state, recaptcha_public_v2: action.recaptcha_public_v2 }
    default: return state
  }
}

export default generalReducer